import { DialogTitle } from '@headlessui/react';
import { Modal } from '@retainerclub/common';
import PropTypes from 'prop-types';
import ManageSubscription from './ManageSubscription';

function ManageSubscriptionModal({
  open,
  handleCloseModal,
  activeSubscription = null,
  refetch,
}) {
  return activeSubscription ? (
    <Modal open={open} setOpen={handleCloseModal} size="2xl">
      <div>
        <div className="text-center">
          <DialogTitle
            as="h2"
            className="font-semibold text-2xl text-rcgray-900 capitalize leading-4"
          >
            Manage {activeSubscription.patient.firstName}
            {`'s `}Plan
          </DialogTitle>
        </div>
        <ManageSubscription
          subscription={activeSubscription}
          handleCloseModal={handleCloseModal}
          refetch={refetch}
        />
      </div>
    </Modal>
  ) : null;
}

ManageSubscriptionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  activeSubscription: PropTypes.object,
  refetch: PropTypes.func.isRequired,
};

export default ManageSubscriptionModal;
